import anychart from 'anychart';
import _ from "lodash";
import {money, stringMixin} from "../../utils/strings";
import {getRandomColor, toRGB} from "../../utils/colorUtils";

let _toArray = (o)=>{
  let a = [];
  for (let k in o){
    a.push({id: k, wgt: o[k].wgt, value: o[k].value});
  }
  a.sort((a, b)=>{return b.wgt - a.wgt});
  return a;
}

const formatSnapshotString = (timestamp, value, snapshot, showZero=false)=>{
  let snapshotArray = _toArray(snapshot);
  if (showZero===false){
    snapshotArray = snapshotArray.filter(x=>x.wgt>0);
  }
  let snapshotStringArray = snapshotArray.map((x=>{
    return `<span style="color:#777777;font-family:var(--font-title);font-size:12px">${x.id.toUpperCase()}: ${stringMixin.pct(x.wgt)}</span>`
  }))
  snapshotStringArray.unshift(`<b style="color:#777777">Value: ${money(value)}</b>`);
  return snapshotStringArray.join('<br>');

}



export const getTooltipContent = ({
                                      seriesData,
                                      lastHoveredTimestamp,
                                      setLastHoveredTimestamp,
                                      setLastHoveredPoint,
                                      showSnapshotTooltip,
                                      precision,
                                      tooltipDisabled=false
                                  }) => {
    return function () {
        const hoveredTimestamp = this.x;
        if (tooltipDisabled) {
            return <div>{hoveredTimestamp}</div>;
        }
        const matchingDataPoint = seriesData.find(point => new Date(point[0]).getTime() === hoveredTimestamp);
        if (matchingDataPoint && Array.isArray(matchingDataPoint) && matchingDataPoint.length > 2) {
            if (hoveredTimestamp !== lastHoveredTimestamp) {
              setLastHoveredTimestamp(hoveredTimestamp);
              const copiedSnapshot = _.cloneDeep(matchingDataPoint[2]);
              setLastHoveredPoint({...copiedSnapshot});
            }
            if (showSnapshotTooltip) {
                return formatSnapshotString(...matchingDataPoint);
            }

            return `${this?.seriesName} ${this?.value?.toFixed(2)}`;
        } else {
          return `Value: ${this?.value?.toFixed?.(precision) ?? '--'}`;
        }
    }

};

class SeriesItemConfig {

    constructor(config) {
        this.config = config;
        this.plotType = config?.type ?? 'line';
        this.name = config?.name ?? '';
        this.stroke = {
            color: config?.stroke,
            thickness: config?.thickness ?? 1,
            dash: config?.dotted ? '2 2' : null


        }
        this.prefix = config?.prefix ?? '';
        this.postfix = config?.postfix ?? '';
        this.precision = config?.precision ?? 2;
        
    }
    
    maybeApplyStyles(series){
        try {
            if (this.config.hasOwnProperty('fill') && this.plotType !== 'line') {
                series.fill(this?.config?.fill);
            }
        }
        catch (e) {
        }
        if (['rangeSplineArea', 'rangeArea'].includes(this.plotType)){
            series.highStroke(this.stroke);
            series.lowStroke(this.stroke);
        }
        if (this.plotType==='column'){
            series.pointWidth(100)
        }
        series.stroke(this.stroke);
    }

    styleValue(value){
        return `${this.prefix}${value.toFixed(this.precision)}${this.postfix}`;
    }
}


export const fillSeriesFromConfig = (config, plot, dataMapping, lastHoveredTimestamp, setLastHoveredTimestamp,
                                     setLastHoveredPoint, showSnapshotTooltip, tooltipDisabled=false) => {
  const seriesConfig = new SeriesItemConfig(config);
  const plotType = config?.type ?? 'line';
  let series = plot[plotType](dataMapping);
  series.name(seriesConfig.name);
  seriesConfig.maybeApplyStyles(series);
  series.tooltip().enabled(!tooltipDisabled);


  // Check if the series has snapshot data to be displayed in the tooltip
  if (config.hasSnapshot) {
    series.tooltip().format(
        getTooltipContent({
            lastHoveredTimestamp, setLastHoveredTimestamp, setLastHoveredPoint, showSnapshotTooltip,
            precision: seriesConfig.precision,
            seriesData: config.data,
            tooltipDisabled
        })); // Set the tooltip content using the closure
  }
  else {

    series.tooltip().format(function() {
        if (showSnapshotTooltip) {
            return showSnapshotTooltip ? `${this?.seriesName}: ${seriesConfig.styleValue(this?.value??0)}` : '';
        }
    });
  }
  return series;
};

/**
 * Handle the series data and configuration to create a data table and mapping for each series item added to a plot
 * @param data
 * @param config
 * @returns {{mapping: {x: number}, dataTable: *}}
 */
export const handleSeriesItem = (data, config)=>{
    const dataTable = anychart.data.table();

    let dataTableRows = data.map(item => [new Date(item[0]).getTime(), item[1]]);
    let mapping = { 'x': 0, [config?.valueKey??'value']: 1 };

    if (config.hasOwnProperty('extraFields')){
        config.extraFields.forEach((field, index)=>{
            mapping[field] = index+2;
            data.forEach((item, itemIndex)=>{
                dataTableRows[itemIndex].push(item[index+2]);
            })
        });
    }
    else if (config?.hasSnapshot===true){
        mapping.snapshot = 2;
    }
    dataTable.addData(dataTableRows);
    return {dataTable, mapping}
}



